import { render } from "./OrganizationStructure.vue?vue&type=template&id=06190b90&scoped=true"
import script from "./OrganizationStructure.vue?vue&type=script&lang=js"
export * from "./OrganizationStructure.vue?vue&type=script&lang=js"

import "./OrganizationStructure.vue?vue&type=style&index=0&id=06190b90&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06190b90"]])

export default __exports__